<template>
  <div class="message_template" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="tittle" placeholder="请输入模板标题" title="模板标题"/>
      </div>
      <div class="date_selected fixed_search_input">
        <el-date-picker v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始创建时间" end-placeholder="结束创建时间" align="left" :default-time="['00:00:00', '23:59:59']" :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button class="search_btn" type="success" style="margin-left: 10px;" @click="addTemplate" v-if="roleList['5_3-1']">添加</Button>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
        <el-table-column  fixed="right" label="操作" width="150" v-if="contentList.length>0"  align="center">
          <template slot-scope="scope">
            <el-button @click="editMessageTemplate(scope.row)" type="text" size="small" v-if="roleList['5_3-2']">编辑</el-button>
            <el-button @click="deleteMessageTemplate(scope.row.id)" type="text" size="small" v-if="roleList['5_3-3']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <messageTemplateEdit @closeNoteEdit="closeNoteEdit" :showNoteEdit="showNoteEdit"  :noteContent="noteContent"></messageTemplateEdit>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import messageTemplateEdit from '@/components/MessageManage/MessageTemplateEditPop.vue'
  export default {
    name: "MessageTemplate",
    mixins:[publicFunClass],
    components:{
      messageTemplateEdit
    },
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        total:0,
        currentPage:1,
        speedChangePage: 1,
        pageSize:20,
        editable:false,
        pageSizeList:[10,20,30,40,50,100,200],
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        showNoteEdit: false,
        noteContent:[],
        starEndTime:[],
        tittle:'',
        screenHeight:{height:''},
        tableHeight:600,
        spinShow: true,
        checkIds:[],
        fieldList: [
         {key:'tittle','title':'标题'},{key:'content','title':'内容'},{key:'description','title':'描述'},{key:'createTime','title':'创建时间'}
        ],
        contentList: [],
        selection:''
      }
    },
    methods:{
      closeNoteEdit:function(flag){
        this.showNoteEdit=false;
        this.noteContent=[];
        if(flag){
          this.initSearch();
        }
      },
      addTemplate:function(){
        this.showNoteEdit=true;
        this.noteContent=[];
      },
      editMessageTemplate:function(noteContent){
        this.showNoteEdit=true;
        this.noteContent.push(noteContent)
      },
      deleteMessageTemplate:function(id){
        let journalType="短信管理=>短信模板=>删除";
        let menuId="9_3-7";
        let param={
          journalType:journalType,
          menuId:menuId,
          id:id
        };
        let that=this;
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("message/doDelete.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定'
                });
                return false;
              }
              that.$Message.info("删除成功");
              that.initSearch();
            })
          }
        });
      },
      reset:function(){
        this.tittle='';
        this.starEndTime=[];
      },
      initSearch:function () {
        let that=this;
        this.spinShow=true;
        let param={
          tittle:this.tittle,
          createTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null"
        };
        this.$http.post("message/toTemplateIndex.json",param) .then(function (res) {
          that.spinShow=false;
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          let obj=res.data.obj;
          that.contentList=obj.list.content;
          that.total=res.data.obj.list.totalSize;
        });
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-182;
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='5_3' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MessageManage/MessageTemplate.vue